module.exports = __webpack_public_path__ + "img/953-04413d.png";